import { CommonModule } from '@angular/common';
import { Component, ComponentRef, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { SystemNotificationConfig, SystemNotificationRef } from '../../types/system-notification.interface';

@Component({
  selector: 'app-blocking-overlay',
  imports: [CommonModule],
  templateUrl: './system-notification.component.html',
  styleUrls: ['./system-notification.component.scss'],
})
export class SystemNotificationComponent implements OnInit, OnDestroy {
  @Input() config: SystemNotificationConfig = {};
  @Input() overlayRef: SystemNotificationRef | null = null;

  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef }) dynamicComponentContainer!: ViewContainerRef;

  private componentRef: ComponentRef<unknown> | null = null;

  ngOnInit(): void {
    if (this.config.component) {
      this.loadDynamicComponent();
    }
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

  private loadDynamicComponent(): void {
    if (this.config.component && this.dynamicComponentContainer) {
      this.componentRef = this.dynamicComponentContainer.createComponent(this.config.component);

      if (this.config.componentData && this.componentRef.instance) {
        Object.assign(this.componentRef.instance, this.config.componentData);
      }

      if (this.overlayRef) {
        this.overlayRef.componentRef = this.componentRef;
      }
    }
  }

  onBackdropClick(): void {
    if (this.config.dismissible && this.overlayRef) {
      this.overlayRef.close();
    }
  }

  onActionClick(action: () => void): void {
    action();
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }
}
